var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"feed"},[_c('div',{staticClass:"masonry-container"},_vm._l((_vm.pins),function(pin,index){return _c('FeedPin',{key:index,attrs:{"pin":pin}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }